import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ReportService } from '../Services/ReportService';

import 'rxjs/add/operator/map';

@Component({
  selector: 'Reports',
  templateUrl: '../Reports/ReportDashboard.html',
  styleUrls: ['../../Content/css/bootstrap.css', '../../Content/css/custom.css', '../../Content/css/master.css', '../../Content/css/innflow-top-menu.css',
    '../../Content/css/innflow-main.css'],
  providers: [ReportService]
})
export class ReportDashboardComponent implements OnInit {
  innerWidth: number = 100;
  loading: boolean;
  Loaderimage: string = '../../assets/images/ajax-loader3.gif';
  GetreportDetails: any = [];
  constructor(private _reportService: ReportService,private router :Router) { this.innerWidth = 100; }
  ngOnInit() {
    this.GetAllReports();
    this.ChangeHeadeFooterColor();
  }

  GetAllReports() {
    this.loading = true;
    this._reportService.GetAllReports().subscribe(res => {
      var data = res;
      this.GetreportDetails = data;
      console.log(data);
      this.loading = false;
    })
  }

  get_url: string = '';
  public ChangeHeadeFooterColor() {

    this.get_url = window.location.origin;
    if (this.get_url == "https://localhost:44335") {
      var a = document.getElementById("mainbox");
      a.style.backgroundColor = "#cc4141";

      var footer = document.getElementById("footer");
      footer.style.background = "#cc4141";

      var header = document.getElementById("header");
      header.style.background = "#cc4141";

      // var mnu_Reports = document.getElementsByTagName("ul[_ngcontent-c2] li[_ngcontent-c2]");


    }
    else if (this.get_url == "https://inn-flowmgt-test.azurewebsites.net") {
      var a = document.getElementById("mainbox");
      a.style.backgroundColor = "#cc4141";

      var footer = document.getElementById("footer");
      footer.style.background = "#cc4141";

      var header = document.getElementById("header");
      header.style.background = "#cc4141";

    }
    else if (this.get_url == "https://inn-flowmgt-staging.azurewebsites.net") {
      var a = document.getElementById("mainbox");
      a.style.backgroundColor = "#ed7d31";

      var footer = document.getElementById("footer");
      footer.style.background = "#ed7d31";

      var header = document.getElementById("header");
      header.style.background = "#ed7d31";
    }
  }

  RedirectPage(Report: any)
  {
    
     this.router.navigate(['/PLGroupingReports', { ReportName: btoa(JSON.stringify(Report.Report)), ReportID: btoa(JSON.stringify(Report.Uniqueno)), PageName: btoa(JSON.stringify('Reports')) }]);
  }
 }



// WEBPACK FOOTER //
// ./src/app/Reports/ReportDashboardComponent.ts